import Splide from '@splidejs/splide';
new Splide( '.splide', {
    perPage: 3,
    perMove: 1,
    gap: 'var(--wp--preset--spacing--24-12)',
    arrows: true,
    pagination: true,
    breakpoints: {
		782: {
			perPage: 2,
		},
        600: {
            perPage: 1,
            pagination: false
        }
    },
} ).mount();
/* eslint-enable no-console */
